import { useEffect, useRef } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
	SEGMENT_EVENTS,
	segmentCondition,
	segmentPayloads,
} from "assets/js/const/SegmentEvents";
import { isMobile } from "react-device-detect";
import fetchRoute from "utils/routes";
import { getUtmCookies, preparePlausibleUrl } from "utils/urlUtils";
import { posthog } from "posthog-js";

const GenericWrapper = (props) => {
	useEffect(() => {
		if (isMobile) {
			document.body.className += " mobile";
		}
	}, []);
	const previousLocation = useRef();
	useEffect(() => {
		const {
			location: { hash },
		} = props;

		if (hash !== previousLocation.current) {
			if (window?.Appcues) window.Appcues.page();
			previousLocation.current = hash;
		}
	});

	return props.children;
};

export default withRouter(
	connect(
		(state) => {
			return {
				segmentDisabledEvent:
					state.brand?.client_config?.segment_config?.disabled_events,
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(GenericWrapper)
);
